// C:\Users\Myshka\Desktop\MyClientDriveWeb\src\App.js
import React, { useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import { ToastProvider } from './Toast/ToastContainer';
import PortalLogin from './components/PortalLogin';
import ClientDashboard from './components/ClientDashboard';
import MfaEnrollment from './components/MfaEnrollment';

function App() {
    useEffect(() => {
        if (typeof window !== 'undefined') {
            const path = window.location.pathname;

            // If someone visits /2 or /2/#/login, ensure they are on /2/login/#/
            if (path === '/2' || path.startsWith('/2/')) {
                if (!path.startsWith('/2/login')) {
                    window.location.replace('/2/login/#/');
                    return;
                }
            }

            // Normalize root or /3 visits to /3/clientportal/
            if (path === '/' || path === '' || path === '/3' || path === '/3/') {
                const currentHash = window.location.hash || '#/login';
                window.history.replaceState(null, '', `/3/clientportal/${currentHash}`);
            }
        }
    }, []);

    return (
        <ToastProvider>
            <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
                <Routes>
                    <Route path="/" element={<Navigate to="/login" replace />} />
                    <Route path="/login" element={<PortalLogin />} />
                    <Route path="/portal-login" element={<PortalLogin />} />
                    <Route path="/mfa-setup" element={<MfaEnrollment />} />
                    <Route path="/dashboard" element={<ClientDashboard />} />
                    <Route path="/portal-dashboard" element={<ClientDashboard />} />
                    <Route path="*" element={<Navigate to="/login" replace />} />
                </Routes>
            </div>
        </ToastProvider>
    );
}

export default App;